import { RetargetingBlock } from './RetargetingBlock'

export const retargetingBlocks = [RetargetingBlock] as const
